import NewCustomer from "../pages/customer/manageCustomer/NewCustomer";
import DetailCustomer from "../pages/customer/manageCustomer/DetailedCustomer";
import EditCustomer from "../pages/customer/manageCustomer/EditCustomer";
import ManageCustomer from "../pages/customer/manageCustomer/ManageCustomer";
import casaAccountDetails from "../pages/customer/manageCustomer/DetailedCustomer/components/casaAccountDetails/casaAccountDetails";
import NewAddress from "../pages/customer/manageCustomer/DetailedCustomer/tabs/address/NewAddress";
import EditAddress from "../pages/customer/manageCustomer/DetailedCustomer/tabs/address/EditAddress";
import NewRelationship from "../pages/customer/manageCustomer/DetailedCustomer/tabs/relationship/NewRelationship";
import EditRelationship from "../pages/customer/manageCustomer/DetailedCustomer/tabs/relationship/EditRelationship";
import DetailCharge from "../pages/customer/manageCustomer/DetailedCustomer/tabs/charges/DetailCharge";
import PayCharge from "../pages/customer/manageCustomer/DetailedCustomer/tabs/charges/PayCharge";
import ManageServiceProvider from "../pages/serviceProvider/ManageServiceProvider";
import NewServiceProvider from "../pages/serviceProvider/NewServiceProvider";
import EditServiceProvider from "../pages/serviceProvider/EditServiceProvider";
import DetailServiceProvider from "../pages/serviceProvider/DetailServiceProvider";
import DeactivateServiceProvider from "../pages/serviceProvider/actions/Deactivate";

export default [
  {
    path: "/service-provider",
    component: ManageServiceProvider,
    isProtected: true,
  },
  {
    path: "/detail-service-provider",
    component: DetailServiceProvider,
    isProtected: true,
  },
  {
    path: "/deactivate-service-provider",
    component: DeactivateServiceProvider,
    isProtected: true,
  },
  {
    path: "/new-service-provider",
    component: NewServiceProvider,
    isProtected: true,
  },
  {
    path: "/edit-service-provider",
    component: EditServiceProvider,
    isProtected: true,
  },
  {
    path: "/new-address",
    component: NewAddress,
    isProtected: true,
  },
  {
    path: "/edit-address",
    component: EditAddress,
    isProtected: true,
  },
  {
    path: "/casa-account-details",
    component: casaAccountDetails,
    isProtected: true,
  },

  {
    path: "new-relationship",
    component: NewRelationship,
    isProtected: true,
  },
  {
    path: "edit-relationship",
    component: EditRelationship,
    isProtected: true,
  },
  {
    path: "/detail-charge",
    component: DetailCharge,
    isProtected: true,
  },
  {
    path: "/pay-charge",
    component: PayCharge,
    isProtected: true,
  },
];
